import { ProductType, RetailChannel } from '@app/shared/utils';
import { createSelector } from '@ngrx/store';
import { AppState } from '..';
import { ProductsState } from '@app/store/products/products.state';

const productsState = (state: AppState) => state.products;

export const selectPriceListToUpdate = createSelector(productsState, (state) => state.priceListToUpdate);

export const selectPriceListUpdateLoading = createSelector(productsState, (state) => state.priceListUpdateLoading);

export const selectShowPriceListActions = createSelector(productsState, (state) => state.showPriceListActions);

export const selectAllProductsSuccess = createSelector(productsState, (state) => state.allProductList);

export const selectHasWetInAllProducts = createSelector(
  productsState,
  (state) => !!state.allProductList.filter((products) => products.productType === ProductType.Wet).length
);
export const selectHasDryInAllProducts = createSelector(
  productsState,
  (state) => !!state.allProductList.filter((products) => products.productType === ProductType.Dry).length
);
export const selectFilteredProducts = createSelector(productsState, (state) => state.filteredProductList);

export const selectFilteredProductsFlatten = createSelector(productsState, (state) => Object.values(state.filteredProductList).flat());

export const selectSpecificSpecieCode = createSelector(productsState, (state) => state.specificSpecieCode);

export const selectSpecificLifestageType = createSelector(productsState, (state) => state.specificLifestageType);

export const selectProductsLoading = createSelector(productsState, (state) => state.productsLoading);

export const selectFilteredProductsLength = createSelector(productsState, (state) => state.filteredProductLength);

export const selectFiltersValues = createSelector(productsState, (state) => state.filtersValues);

export const selectSelectedCategories = createSelector(productsState, (state) => state.selectedCategories);

export const selectCurrentViewType = createSelector(productsState, (state) => state.currentViewType);

export const selectCurrentPillar = createSelector(productsState, (state) => state.filtersValues?.pillar);

export const selectGetAllProductsFail = createSelector(productsState, (state) => state.getAllProductsFail);

export const selectMufProductsBySpecie = createSelector(selectAllProductsSuccess, selectFiltersValues, (allProducts, filtersValues) =>
  allProducts.filter((product) => product.retailChannel === RetailChannel.MULTIFUNCTION && product.speciesCode === filtersValues.specie)
);

export const selectSelectedDryProduct = createSelector(
  productsState,
  (state: ProductsState) => state?.selectedProducts?.find((product) => product?.product?.productType === ProductType.Dry)?.product
);
export const selectSelectedWetProduct = createSelector(
  productsState,
  (state: ProductsState) => state?.selectedProducts?.find((product) => product?.product?.productType === ProductType.Wet)?.product
);

export const selectSelectedProducts = createSelector(productsState, (state: ProductsState) =>
  state?.selectedProducts?.map((selectedProduct) => selectedProduct?.product)
);
export const selectedSelectedProductsAndPacks = createSelector(productsState, (state: ProductsState) => state?.selectedProducts);

export const selectSelectedPackIds = createSelector(productsState, (state: ProductsState) =>
  state?.selectedProducts?.map((item) => item.packId).filter((item) => !!item)
);

export const selectSelectedDryPackId = createSelector(
  productsState,
  (state) => state?.selectedProducts?.find((selectedProduct) => selectedProduct?.product?.productType === ProductType.Dry)?.packId
);

export const selectSelectedWetPackId = createSelector(
  productsState,
  (state) => state?.selectedProducts?.find((selectedProduct) => selectedProduct?.product?.productType === ProductType.Wet)?.packId
);

export const selectSelectedDryPack = createSelector(selectSelectedDryProduct, selectSelectedDryPackId, (product, packId) =>
  product?.packages?.find((item) => item.sCode === packId)
);

export const selectSelectedWetPack = createSelector(selectSelectedWetProduct, selectSelectedWetPackId, (product, packId) =>
  product?.packages?.find((item) => item.sCode === packId)
);
